// extracted by mini-css-extract-plugin
module.exports = {"invitation":"Inviation_invitation__3Th1B","content":"Inviation_content__3GdSM","logo":"Inviation_logo__2h4CV","card":"Inviation_card__1rqaw","button":"Inviation_button__tTB3g"};